
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Endometrial_cancer",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Endometrial_cancer.vue